exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dyna-travel-flight-proposal-details-is-loading {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-evenly;\n  height: 100%;\n  padding: 9%;\n  text-align: center;\n  color: gray;\n}\n.dyna-travel-flight-proposal-details-is-loading__m1 {\n  font-size: 24px;\n  font-weight: 900;\n}\n.dyna-travel-flight-proposal-details-is-loading .loading-inline i {\n  font-size: 92px;\n}\n.dyna-travel-flight-proposal-details-is-loading__progress-number {\n  font-size: 46px;\n  font-weight: 900;\n}\n.dyna-travel-flight-proposal-details-is-loading__m2 {\n  display: none;\n  font-size: 18px;\n  font-weight: 900;\n}\n", ""]);

// exports
